export enum FlowEnums {
    CHECK_IN = 'check_in',
    LOGIN = 'login',
    ROSTER = 'roster',
    SUBMIT = 'submit',
}